<div class="adequacy-period-cell-renderer"
     (click)="toggleExpand()">
  <al-progress-bar [value]="hasNoPlanification ? undefined : adequacy"
                   [status]="status"
                   [isLoading]="isLoading"
                   [titleKey]="hasNoPlanification ? 'resource-management.planningBoard.grid.nothingPlanned' : 'resource-management.planningBoard.grid.adequacy'"
                   unit="%" />

  <al-period-sums [isVisible]="node?.expanded && isResourceRow"
                  [plannedHours]="plannedHours"
                  [actualHours]="actualHours" />
</div>

<al-cell-drop-zone [node]="node"
                   [droppable]="isDroppable"
                   [period]="period?.hasActualHours ? undefined : period"
                   (dragOverDelay)="expand()" />